var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-card"},[(_vm.isLoading)?_c('loading'):(!_vm.hasAuthorize.getById)?_c('no-auth'):(!_vm.project)?_c('not-found'):_c('div',[_c('PageTitle',{attrs:{"title":_vm.$t('project.copy', {
          model: _vm.project.model,
        }),"description":_vm.$t('project.copyDescription')}}),_c('ProjectForm',{attrs:{"project":_vm.project}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }